export default class WaitlistTerms {
  #maxLength = 104;
  constructor(terms) {
    this.terms = terms;
    this.node = document.createElement('div');
    this.hidden = true;
    this.#init();
  }

  // Initializes the terms and conditions pod
  #init() {
    const termsPod = document.createElement('div');
    termsPod.classList.add('WaitlistModal__terms');
    const termsRow = document.createElement('div');
    termsRow.classList.add('WaitlistModal__row');
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.name = 'waitlist_marketing';

    const termsWrapper = document.createElement('span');
    termsWrapper.classList.add('WaitlistModal__terms-wrapper');
    termsWrapper.innerHTML = `
      ${this.terms.substring(0, this.#maxLength).trim()}<span class="WaitlistModal__terms-expand">... <u>more</u></span>
      <span id="terms-hidden" class="WaitlistModal__terms--hide">
        ${this.terms.substring(this.#maxLength).trim()}
      </span>
    `;

    // Expand and collapse terms on click
    termsWrapper.addEventListener('click', () => {
      const moreButton = termsWrapper.querySelector('.WaitlistModal__terms-expand');
      const termsHidden = termsWrapper.querySelector('#terms-hidden');
      termsHidden.classList.toggle('WaitlistModal__terms--show');
      termsHidden.classList.toggle('WaitlistModal__terms--hide');
      moreButton.classList.toggle('WaitlistModal__terms-expand-hide');
    });

    // Whenever you hit checkbox, it will remove any error class
    checkbox.addEventListener('change', () => {
      if (checkbox.classList.contains('WaitlistModal__checkbox-error')) {
        checkbox.classList.remove('WaitlistModal__checkbox-error');
        termsWrapper.classList.remove('WaitlistModal__terms-wrapper-error');
      }
    });

    termsRow.appendChild(checkbox);
    termsRow.appendChild(termsWrapper);
    termsPod.appendChild(termsRow);
    this.node.appendChild(termsPod);
  }
}
